import React from 'react';
import { AlertTriangle } from 'lucide-react';

/** Keeps a failure inside the AI panel instead of blanking the whole app. */
export class PanelErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  componentDidCatch(error) { console.error('Officium AI panel error', error); }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="flex h-full flex-col items-start gap-2 p-4 text-xs text-slate-600" data-testid="kb-ai-panel-error">
        <span className="inline-flex items-center gap-1.5 font-medium text-amber-700">
          <AlertTriangle className="h-4 w-4" />Officium AI hit a problem
        </span>
        <p>Your page is safe and still open. Reopen the panel to start again.</p>
        <button type="button" onClick={() => this.setState({ failed: false })}
          className="rounded-full border border-slate-200 px-3 py-1 hover:border-indigo-300 hover:text-indigo-700"
          data-testid="kb-ai-panel-retry">Try again</button>
      </div>
    );
  }
}
